"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Username = function Username(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M12.003 17.634a5.592 5.592 0 002.632-.654.625.625 0 01.609 1.092 6.878 6.878 0 113.632-6.065c0 1.9-1.12 3.44-2.5 3.44a2.497 2.497 0 01-2.175-1.273 3.166 3.166 0 01-2.667 1.585c-1.811 0-3.28-1.68-3.28-3.752 0-2.071 1.468-3.75 3.28-3.75.91.011 1.767.424 2.343 1.127v-.157a.648.648 0 01.52-.65.625.625 0 01.73.617v3.751a1.25 1.25 0 001.25 1.25c.69 0 1.249-.979 1.249-2.188a5.624 5.624 0 10-5.623 5.627zm-.313-8.128c-1.208 0-2.187 1.12-2.187 2.501 0 1.382.98 2.501 2.187 2.501 1.208 0 2.187-1.12 2.187-2.5 0-1.382-.979-2.501-2.187-2.501z"
  }));
};

var _default = (0, _react.forwardRef)(Username);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Username, "Username", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Username.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Username.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();